import React, { useEffect, useState } from "react";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDelete, MdDeleteForever, MdEdit } from "react-icons/md";
import CreateDesignations from "./addDesignations";
import MapDesignationsAndPackage from "./packagesAndDesignationsMapping";
import "./Spinner.css";
import "./Loader.css";
import UploadDesignationsCsvFile from "./designationCsvUpload";
import DesinationCsvFormat from "./designationCsvFormat";
import { useNavigate } from "react-router";
import { FiInfo } from "react-icons/fi";
import TestForPackage from "./testsByPackagePopup";
import { RxCross2, RxPlus } from "react-icons/rx";
import { FaPlus, FaPlusCircle } from "react-icons/fa";
import { Modal, Button } from "react-bootstrap";
import { Form } from "react-router-dom";
import AddAgesPopup from "./addAgesPopup";


function Designations({ selectedOrgcode }) {
  const [packageDesignationAge, setPackageDesignationAge] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [isMapDesignationAndPackage, setIsMapDesignationAndPackage] = useState(false);
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [isCsvUplaodModalOpen, setIsCsvUplaodModalOpen] = useState(false);
  const [company, setCompany] = useState(null);
  const [selectedDes, setSelectedDes] = useState(null);
  const [selectedPkg, setSelectedPkg] = useState(null);
  const [selectedGender, setSelectedGender] = useState(null);

  const token = JSON.parse(localStorage.getItem("data")).token;

  console.log("org", selectedOrgcode);

  

const getData = async () => {
  setLoader(true);
  try {
    const companyRes = await axios.get(
      `/api/companydetails/companycode=${selectedOrgcode}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const companyData = companyRes.data;
    
    // Check if data is null or invalid
    if (!companyData || !companyData.id) {
      throw new Error("Company data not found or invalid.");
    }

    setCompany(companyData);

    const payload = {
      companyId: companyData.id,
    };

    // Safe check before accessing properties
    if (
      companyData.restrictedPkgByDesignation === false &&
      companyData.packageByAge === false
    ) {
      const designationRes = await axios.get(
        `/api/designation/companyId=${companyData.id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setPackageDesignationAge(designationRes.data);
    } else {
      const packageRes = await axios.post(
        `/api/packageDesignationAgeMapping`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setPackageDesignationAge(packageRes.data);
    }

    setLoader(false);
  } catch (error) {
    console.error("Error fetching data:", error);
    setLoader(false);
    handleError(error);
  }
};

  useEffect(() => {
  if (selectedOrgcode) {
    getData();
  }
}, [selectedOrgcode]);
  const navigate = useNavigate();
  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      }  else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
       else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }


  const handleCreateCompany = () => {
    setSelectedDesignation(null);
    setIsModalOpen(true);
  };

  const handleEditDesignation = (designation) => {
    setSelectedDesignation(designation);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    getData();
  };

  const handleOpenMapPopup = (designationId) => {
    setSelectedDesignation(designationId);
    setIsMapDesignationAndPackage(true);
  };

  const handleCloseMapPopup = () => {
    setSelectedDesignation(null);
    setIsMapDesignationAndPackage(false);
    getData();
  };

  const handleDeleteDesignation = async (id) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    setLoader(true); // set loader to true when deleting
    try {
      await axios.delete(`/api/designation/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Deleted successfully");
      getData(); // reload data after deletion
    } catch (error) {
      toast.error("Failed to delete designation.");
    } finally {
      setLoader(false); // reset loader after deletion attempt
    }
  };

  const [showImageModal, setShowImageModal] = useState(false);

  const handleShowImageModal = () => setShowImageModal(true);
  const handleCloseImageModal = () => setShowImageModal(false);

  const [showAgeModal, setShowAgeModal] = useState(false);

  const handleShowAgeModal = (designation, pkg, gender) => {
    setSelectedDes(designation);
    setSelectedPkg(pkg);
    setSelectedGender(gender);
    setShowAgeModal(true);
  };

  const closeAgeModal = () => {
    setSelectedDes(null);
    setSelectedPkg(null);
    setSelectedGender(null);
    setShowAgeModal(false);
    getData();
  };

  const uploadCsv = () => {
    setIsCsvUplaodModalOpen(true);
  };

  const closeUploadModal = () => {
    setIsCsvUplaodModalOpen(false);
    getData();
  };
const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
const [selectedPackage, setSelectedPackage] = useState(null);
const openTestsModal = (pkg) => {
  setSelectedPackage(pkg);
    setIsTestsModalOpen(true);
};

const closeTestsModal = () => {
  setSelectedPackage(null);
  setIsTestsModalOpen(false);
};
    const handleDeleteAge = async (mappingId, age) => {
      if (window.confirm(`Delete age ${age}?`)) {
        const payload = { id: mappingId };
    
        try {
          const response = await axios.delete(`/api/packagedesignationmapping`, {
            headers: { Authorization: `Bearer ${token}` },
            data: payload, // this is how DELETE requests should send a body
          });
    
          if (response.status === 200) {
            toast.success("Age Deleted successfully");
            getData();
          }
        } catch (error) {
          handleError(error);
        }
      }
    };
    
    

  return (

    <div>
        {loader && <div className="loading"></div>}
      <div className="company-profile">
        <div className="card card-raised mb-5">
          <div className="card-body">
            <div className="card-title form-group d-flex align-items-center justify-content-between">
              <span>Designations And Packages</span>
              <div>
                <button className="btn btn-primary me-5" onClick={handleShowImageModal}>
                  View Format
                </button>
                <button className="btn btn-primary me-5" onClick={uploadCsv}>
                  UPLOAD CSV
                </button>
                <button className="btn btn-primary" onClick={handleCreateCompany}>
                  ADD
                </button>
              </div>
            </div>
            <br />
            
            {company?.restrictedPkgByDesignation === false && company?.packageByAge === false ? (
  <table className="table table-bordered">
  <thead>
    <tr className="table-header">
      <th>Designation</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {packageDesignationAge.length === 0 ? (
      <tr>
        <td colSpan="2" className="text-center">No Data Available</td>
      </tr>
    ) : (
      packageDesignationAge.map((designation) => (
        <tr key={designation.designationId}>
          <td>{designation.designation}</td>
          <td>
            <MdEdit
              style={{ cursor: "pointer", marginRight: "10px" }}
              title="Edit"
              onClick={() => handleEditDesignation(designation.designationId)}
            />
          </td>
        </tr>
      ))
    )}
  </tbody>
</table>
) : (
  <table className="table table-bordered">
    <thead>
      <tr className="table-header">
        <th>Designation</th>
        <th>Package Name</th>
        <th>Gender</th>
        {company?.packageByAge === true && <th>Age</th>}
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      {packageDesignationAge.length === 0 ? (
        <tr>
          <td colSpan="5" className="text-center">No Data Available</td>
        </tr>
      ) : (
        packageDesignationAge.map((designation) => {
          if (designation.packageDesignationMapping.length === 0) {
            return (
              <tr key={designation.designationId}>
                <td>{designation.designation}</td>
                {company?.packageByAge === true ? <td colSpan="3" className="text-center">No Packages Added</td>: <td colSpan="2" className="text-center">No Packages Added</td>}
              
                <td>
                  <button
                    className="btn btn-link text-primary"
                    style={{ marginRight: "10px" }}
                    onClick={() => handleOpenMapPopup(designation.designationId)}
                  >
                    Link Package
                  </button>
                  <MdEdit
                    style={{ cursor: "pointer", marginRight: "10px" }}
                    title="Edit"
                    onClick={() => handleEditDesignation(designation.designationId)}
                  />
                </td>
              </tr>
            );
          }

          const groupedByPackage = Object.values(
            designation.packageDesignationMapping.reduce((acc, curr) => {
              console.log("Current package:", curr); // Log each `curr` object to see what it contains
              
              const key = curr.packageid;
              if (!acc[key]) {
                acc[key] = {
                  pac: curr.pac, // We expect this to contain the full package object
                  packageid: curr.packageid,
                  genderGroups: {},
                };
              }
          
              if (!acc[key].genderGroups[curr.gender]) {
                acc[key].genderGroups[curr.gender] = new Set();
              }
              if (curr.age) {
                acc[key].genderGroups[curr.gender].add(curr.age);
              }
          
              return acc;
            }, {})
          );
          
          return groupedByPackage.flatMap((pkg, pkgIndex) => {
            const genderEntries = Object.entries(pkg.genderGroups);
          
            return genderEntries.map(([gender, agesSet], idx) => {
              const ages = Array.from(agesSet).sort((a, b) => a - b).join(', ');
          
              return (
                <tr key={`${designation.designationId}-${pkg.packageid}-${gender}`}>
                  {pkgIndex === 0 && idx === 0 && (
                    <td rowSpan={groupedByPackage.reduce((sum, p) => sum + Object.keys(p.genderGroups).length, 0)}>
                      {designation.designation}
                    </td>
                  )}
          
                  {idx === 0 && (
                    <td rowSpan={genderEntries.length}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>{pkg.pac?.packagename}</span>
                        <FiInfo
                          onClick={() => openTestsModal(pkg.packageid)}
                          style={{ cursor: 'pointer', marginLeft: '8px' }}
                          title="View Tests"
                        />
                      </div>
                    </td>
                  )}
          
                  <td>{gender}</td>
          
                  {company?.packageByAge === true && (
                    <td style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        {Array.from(agesSet)
                          .sort((a, b) => a - b)
                          .map((age, index, arr) => (
                            <span key={age} style={{ marginRight: '5px' }}>
                              {age}
                              <RxCross2
                                style={{ color: 'red', cursor: 'pointer', marginLeft: '3px' }}
                                title="Delete Age"
                                onClick={() => {
                                  const match = designation.packageDesignationMapping.find(
                                    m => m.packageid === pkg.packageid && m.gender === gender && m.age === age
                                  );
                                  if (match) handleDeleteAge(match.id, age);
                                }}
                              />
                              {index !== arr.length - 1 && ','}
                            </span>
                          ))}
                      </div>
          
                      <FaPlusCircle
                        title="Add Age"
                        style={{ color: 'green', cursor: 'pointer', marginLeft: '10px' }}
                        onClick={() => {
                          console.log("Clicked Package:", pkg); // Log clicked package to ensure it's correct
                          handleShowAgeModal({
                            designation,  // Pass the current designation
                            pkg,          // Pass the current package object (this will be the clicked package)
                            gender,       // Pass the current gender
                          });
                        }}
                      />
                    </td>
                  )}
          
                  {pkgIndex === 0 && idx === 0 && (
                    <td rowSpan={groupedByPackage.reduce((sum, p) => sum + Object.keys(p.genderGroups).length, 0)}>
                      <button
                        className="btn btn-link text-primary"
                        style={{ marginRight: "10px" }}
                        onClick={() => handleOpenMapPopup(designation.designationId)}
                      >
                        Link Package
                      </button>
                      <MdEdit
                        style={{ cursor: "pointer", marginRight: "10px" }}
                        title="Edit"
                        onClick={() => handleEditDesignation(designation.designationId)}
                      />
                    </td>
                  )}
                </tr>
              );
            });
          });
          
        })
      )}
    </tbody>
  </table>
  
)}
        
            {isModalOpen && (
              <CreateDesignations
                isOpen={isModalOpen}
                onRequestClose={handleCloseModal}
                companyId={company?.id}
                companycode={company?.companycode}
                designationId={selectedDesignation}
              />
            )}

            {isCsvUplaodModalOpen && (
              <UploadDesignationsCsvFile isOpen={isCsvUplaodModalOpen} onRequestClose={closeUploadModal} companyId={company?.id} companycode={company?.companycode} />
            )}

            {showImageModal && (
              <DesinationCsvFormat isOpen={showImageModal} onRequestClose={handleCloseImageModal} />
            )}

            {isMapDesignationAndPackage && (
              <MapDesignationsAndPackage
                isOpen={isMapDesignationAndPackage}
                onRequestClose={handleCloseMapPopup}
                designationId={selectedDesignation}
                companyId={company?.id}
                companycode={company?.companycode}
              />
            )}

{isTestsModalOpen && (
            <TestForPackage
                    isOpen={isTestsModalOpen}
                    onRequestClose={closeTestsModal}
                    packageId={selectedPackage}
                  />
            )}


{showAgeModal && (
            <AddAgesPopup
                    isOpen={showAgeModal}
                    onRequestClose={closeAgeModal}
                    des={selectedDes}
                    pkg={selectedPkg}
                    gender={selectedGender}
                  />
            )}
          </div>
        </div>
      </div>

</div>

  );
}

export default Designations;
